"use client";

import type { ReactNode } from "react";
import type {
  LeadFlowBlockPresentation,
  LeadFlowStepDefinition,
} from "../types";

import { LeadFlowStepProvider } from "./LeadFlowStepContext";
import { Step } from "./Step";

// Questions read `isInert`. The HTML `inert` attribute only blocks input, so
// this is what keeps the copy from fetching or storing answers.
const PREVIEW_STEP_CONTEXT = {
  advance: () => {},
  errors: Object.freeze({}),
  isFirstStep: true,
  isInert: true,
};

type EntryPreviewProps = {
  entry: LeadFlowBlockPresentation["entry"];
  firstStep: LeadFlowStepDefinition;
  header?: ReactNode;
  isOnlyStep: boolean;
  launcher: ReactNode;
};

/**
 * The section keeps its entry content under an open surface, so the page
 * doesn't collapse behind the overlay. It is inert and sits outside the
 * form, so it takes no input and submits nothing.
 */
function EntryPreview({
  entry,
  firstStep,
  header,
  isOnlyStep,
  launcher,
}: EntryPreviewProps) {
  return (
    <div aria-hidden="true" inert>
      {entry === "launcher" ? (
        launcher
      ) : (
        <LeadFlowStepProvider value={PREVIEW_STEP_CONTEXT}>
          <Step
            canShowPanel={false}
            header={header}
            isLastStep={isOnlyStep}
            isReady
            isSubmitPending={false}
            onBack={null}
            step={firstStep}
          />
        </LeadFlowStepProvider>
      )}
    </div>
  );
}

export { EntryPreview };
